import React, { useEffect, useState } from "react";
import { setActiveFooterTab } from "../../store/actions";
import { withRouter } from "react-router-dom";
import { useDispatch } from "react-redux";
import toastr from "toastr";
import startCase from "lodash/startCase";
import { currency } from "../../helpers/constants";
import { getCheckoutSession, getFixtureByIdCall, getLiveFixtureByIdCall } from "../../helpers/repository";
import { ChevronRight, Receipt } from "lucide-react";
import { Trans, useTranslation } from "react-i18next";

function OpenBets(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [fixtureScores, setFixtureScores] = useState({});
  const { myBets } = props;

  useEffect(() => {
    dispatch(setActiveFooterTab("my-bets"));
  }, []);

  const getBetsCountUpper = (mb, ticket) => {
    const bets = mb ?? [];
    const legs = Array.isArray(bets) ? bets.length : 0;
    const isSystem = bets.some((b) => !!b?.system_bet_id) || !!ticket?.system_bet_id;
    if (isSystem) return `${t("mybets_bet_type_system", "SYSTEM")}${legs > 1 ? ` ${legs}` : ""}`;
    if (legs <= 1) return t("mybets_bet_type_single", "SINGLE");
    if (legs === 2) return t("mybets_bet_type_double", "DOUBLE");
    return `${legs}-${t("mybets_bet_type_accumulator", "FOLD ACCUMULATOR")}`;
  };

  useEffect(() => {
    const fetchScores = async () => {
      const scores = {};
      const fixtureIds = new Set();
      myBets.forEach(mb => {
        if (mb?.bets && Array.isArray(mb.bets)) {
          mb.bets.forEach(bet => {
            const bbId = bet?.odd?.fixture_market?.fixture?.bb_id;
            const isLive = bet?.odd?.fixture_market?.fixture?.is_live;
            if (bbId && !isLive) {
              fixtureIds.add(bbId);
            } else if (bbId && isLive) {
              const homeScore = bet?.odd?.fixture_market?.fixture?.home_score;
              const awayScore = bet?.odd?.fixture_market?.fixture?.away_score;
              if (homeScore !== undefined && awayScore !== undefined) {
                scores[bbId] = `${homeScore}:${awayScore}`;
              }
            }
          });
        }
      });
      for (const bbId of fixtureIds) {
        try {
          const response = await getLiveFixtureByIdCall(bbId);
          const fixture = response?.data?.data;
          if (fixture?.home_score !== undefined && fixture?.away_score !== undefined) {
            scores[bbId] = `${fixture.home_score}:${fixture.away_score}`;
          } else {
            scores[bbId] = "-:-";
          }
        } catch (error) {
          try {
            const response = await getFixtureByIdCall(bbId);
            const fixture = response?.data?.data;
            if (fixture?.home_score !== undefined && fixture?.away_score !== undefined) {
              scores[bbId] = `${fixture.home_score}:${fixture.away_score}`;
            } else {
              scores[bbId] = "-:-";
            }
          } catch (err) {
            scores[bbId] = "-:-";
          }
        }
      }
      setFixtureScores(scores);
    };
    // Scores are only shown in the compact (isHome) layout; the My Bets page
    // cards list fixtures only, so skip the per-fixture requests there.
    if (props.isHome && myBets && myBets.length > 0) {
      fetchScores();
    }
  }, [myBets, props.isHome]);

  const _renderOddName = (f, odd) => {
    if (odd?.player) return odd?.player?.name;
    let text = odd?.market_spec?.name ?? "";
    text = text.replaceAll("{$competitor1}", Array.isArray(f?.competitors) ? f?.competitors[0]?.name : "");
    text = text.replaceAll("{$competitor2}", Array.isArray(f?.competitors) ? f?.competitors[1]?.name : "");
    if (text === "u" || text === "o") {
      text = startCase(text) + " " + (odd?.special_bet_value ? odd?.special_bet_value : "");
    } else if (text.includes("{total}")) {
      text = startCase(text).replaceAll("Total", odd?.special_bet_value);
    } else {
      text = startCase(text);
    }
    return text;
  };

  /* ── compact BetSlipWidget layout (isHome=true) ── */
  if (props.isHome) {
    return (
      <>
        <div className="BLM-tab-pane active relative" id="BLM-myBets">
          <div id="getMyBets">
            {myBets?.map((mb, index) => {
              const allCashoutEnabled = mb?.bets?.every(
                (bet) => bet?.odd?.fixture_market?.cashout_status === "1"
              );
              const haveSomeLiveGame = mb?.bets?.some(
                (bet) => bet?.odd?.fixture_market?.fixture?.status === "live"
              );
              return (
                <div className={`BLM-betBox-group !bg-[#212529] mb-3 px-1`} key={index}>
                  <div
                    className="BLM-betBox BLM-accordion collapsed"
                    onClick={() => {
                      $(`#getSettledBetAccordianId_${index}`).toggleClass("collapsed");
                    }}
                    id={`getSettledBetAccordianId_${index}`}
                  >
                    <div className={`BLM-betBox-header BLM-accordion-header BLM-arrowBefore !text-[var(--bet-header-accent)] !px-0 home`}>
                      <div className="BLM-betBox-headerContainer flex flex-col gap-4">
                        <div className="BLM-contentBlock items-center gap-2">
                          <div className="BLM-leftContent">
                            <div className="flex items-center gap-2">
                              <span className={`!text-[var(--bet-header-accent)] !text-[10px] truncate`}>
                                {props.category === "Spribe" ? `${t("mybets_action_id_label", "Action Id")} : ${mb?.action_id}` : `${getBetsCountUpper(mb?.bets ?? [], mb)} - ID: ${mb?.id}`}
                              </span>
                              {haveSomeLiveGame && (
                                <span className="!ml-2 !flex !items-center !gap-1 !text-red-500 !font-semibold !text-xs whitespace-nowrap">
                                  <span className="!w-2 !h-2 !bg-red-500 !rounded-full animate-pulse" />
                                  <Trans i18nKey="mybets_live_badge">LIVE</Trans>
                                </span>
                              )}
                            </div>
                            <div className={`BLM-stake !text-[10px]`}>{`${t("mybets_stake_label", "Stake")}: ${currency} ${mb?.stake ?? mb.amount}`}</div>
                            <div className="BLM-toWin !text-[10px]">
                              {mb.turbo_gametype_id ? "" : mb.game ? "" : `${t("mybets_actual_stake_label", "Actual Stake")}: ${currency} ${props.category === "Spribe" ? mb?.stake : (mb?.stake_after_tax ?? mb.amount)}`}
                            </div>
                          </div>
                          <div className={`BLM-rightContent !text-[10px]`}>
                            <div className="BLM-rightContent !text-[var(--bet-header-accent)]">
                              {new Date(Date.parse(mb?.created_at)).toLocaleDateString()}{" "}
                              {new Date(Date.parse(mb?.created_at)).toLocaleTimeString()}
                            </div>
                            {String(mb?.jackpot_id) === "0" ? (
                              <div>
                                <div className="BLM-toWin !text-[10px]">
                                  {mb.game ? "" : `${t("mybets_total_odds_label", "Total Odds")}: ${mb?.total_odds ?? mb.amount}`}
                                </div>
                                <div className="BLM-toWin !text-[10px]">
                                  {mb.game ? "" : `${t("mybets_to_win_label", "To Win")}: ${currency} ${mb?.to_win}`}
                                </div>
                              </div>
                            ) : (
                              <div className="BLM-toWin !text-[10px]">
                                {mb?.jackpot ? `${t("mybets_to_win_label", "To Win")}: ${currency} ${mb?.jackpot?.max_price}` : ""}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {mb?.bets?.map((bet, i) => {
                      const fixture = bet?.odd?.fixture_market?.fixture;
                      const isLive = fixture?.status;
                      const competitors = fixture?.competitors || [];
                      const matchDate = fixture?.match_date?.$date?.$numberLong
                        ? new Date(parseInt(fixture.match_date.$date.$numberLong))
                        : null;
                      const matchTime = fixture?.match_time ?? null;
                      const formatTime = (date) => (!date ? "-" : new Date(date).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }));

                      return (
                        <div className={`BLM-accordion-content !bg-[#000000] !rounded-xl !mb-3 !border !border-[#1e2a3a] !p-1`} key={i}>
                          <div className="BLM-betBox-content">
                            <div className="BLM-bet-details !space-y-2">
                              <div className="BLM-betSlip-outcomeOdds !flex !justify-between !items-center">
                                <div className="flex gap-1">
                                  <div className={`BLM-betSlip-outcome !text-[var(--bet-header-accent)] !font-semibold !text-[12px]`}>
                                    {_renderOddName(fixture, bet?.odd)}
                                  </div>
                                  {isLive === "live" ? (
                                    <span className="!ml-2 !flex !items-center !gap-1 !text-red-500 !font-semibold !text-xs whitespace-nowrap">
                                      <span className="!w-2 !h-2 !bg-red-500 !rounded-full animate-pulse" />
                                      <Trans i18nKey="mybets_live_badge">LIVE</Trans>{matchTime && <span className="!ml-1 !text-[var(--bet-header-accent)] text-[10px]">{matchTime}'</span>}
                                    </span>
                                  ) : isLive !== "not_started" ? (
                                    <span className="!ml-1 !text-[var(--bet-header-accent)] text-[10px] whitespace-nowrap"><Trans i18nKey="mybets_status_finished">Finished</Trans></span>
                                  ) : (
                                    <span className="!ml-1 !text-[var(--bet-header-accent)] text-[10px] whitespace-nowrap"><Trans i18nKey="mybets_status_upcoming">Upcoming</Trans></span>
                                  )}
                                </div>
                                <div className="BLM-betSlip-odds !text-[var(--bet-header-accent)] !flex !items-center !gap-2">
                                  <span className="!text-[14px]">{parseFloat(bet?.price).toFixed(2)}</span>
                                  <span className={`BLM-betStatus !text-xs !px-2 !py-0.5 !rounded-md whitespace-nowrap BLM-${bet?.is_cancel_by_admin ? "lost" : bet?.status ? "won" : bet?.out_come_for_canceled == "N" || bet?.out_come_for_canceled == "C" ? "lost" : parseFloat(bet?.void_factor) != parseFloat(0) ? "lost" : bet?.is_won === 1 ? "won" : bet?.is_won === 0 ? "lost" : "pending"}`}>
                                    {(bet?.is_cancel_by_admin && t("mybets_status_void", "Void")) || (bet?.status && t("mybets_status_won", "Won")) || (bet?.out_come_for_canceled === "N" || bet?.out_come_for_canceled === "C" ? t("mybets_status_cancel", "Cancel") : parseFloat(bet?.void_factor) !== 0 ? t("mybets_status_void", "Void") : bet?.is_won === 1 ? t("mybets_status_won", "Won") : bet?.is_won === 0 ? t("mybets_status_lost", "Lost") : t("mybets_status_pending", "Pending"))}
                                  </span>
                                </div>
                              </div>
                              <div className="BLM-betSlip-market !text-sm !text-gray-400">{bet?.odd?.fixture_market?.market?.name}</div>
                              <div className="BLM-betSlip-fixture !flex !flex-wrap !items-center !gap-1 !text-white">
                                <span className="text-xs">{competitors[0]?.name ?? "-"} vs {competitors[1]?.name ?? "-"}</span>
                                {isLive === "not_started" && (
                                  <span className="text-xs !ml-auto !text-gray-400">
                                    {matchDate ? matchDate.toLocaleDateString() : "-"}{" "}
                                    <span className="!text-white text-[10px]">({formatTime(matchDate)})</span>
                                  </span>
                                )}
                              </div>
                              <div className="BLM-betSlip-fixture-league !flex !justify-between !items-center !text-gray-300">
                                <span className="text-[10px]">{fixture?.tournament?.name}</span>
                                {isLive !== "not_started" && (
                                  <div className="px-[5px] text-sm whitespace-nowrap">
                                    {isLive === "live" ? t("mybets_live_label", "Live") : t("mybets_status_ft", "FT")}: {fixtureScores[fixture?.bb_id] || "-:-"}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="BLM-divider !bg-[var(--bet-header-accent)] !opacity-40 !mt-3"></div>
                        </div>
                      );
                    })}

                    {mb.game ? (
                      <div className="BLM-accordion-content">
                        <div className="BLM-betBox-content">
                          <div className="BLM-bet-details">
                            <div className="BLM-betSlip-outcomeOdds">
                              <div className="BLM-betSlip-outcome">{mb?.game?.game_name}</div>
                              <div className="BLM-betSlip-odds">{parseFloat(mb?.amount)?.toFixed(2)}</div>
                            </div>
                          </div>
                        </div>
                        <div className="BLM-betBox-stakeRetuns"></div>
                      </div>
                    ) : null}
                  </div>

                  {allCashoutEnabled && mb?.is_signup_freebet_used !== 1 && (
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        props.setIsLoadingId(mb?.id);
                        getCheckoutSession({ ticket_id: mb.id })
                          .then((res) => {
                            props.setIsCashout(true);
                            props.setTicketDetails(res?.data?.data);
                          })
                          .catch((e) => {
                            toastr.error(e?.response?.data?.message || t("mybets_cashout_error_message", "An error occurred while processing cashout. Try again later."));
                          })
                          .finally(() => { props.setIsLoadingId(null); });
                      }}
                      className={`w-full h-fit px-3 my-4 bg-[var(--bet-header-accent)] text-[#0b131c] font-bold !rounded-md !text-sm py-1 truncate`}
                    >
                      {props.isLoadingId !== mb?.id ? t("mybets_cashout_button", "CASHOUT") : t("mybets_please_wait_caps", "PLEASE WAIT...")}
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </>
    );
  }

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(Date.parse(dateStr));
    if (isNaN(d.getTime())) return "";
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, "0");
    const min = String(d.getMinutes()).padStart(2, "0");
    return `${dd}/${mm}/${yyyy} ${hh}:${min}`;
  };

  const formatAmount = (v) => {
    const n = parseFloat(v);
    return Number.isNaN(n) ? "-" : n.toFixed(2);
  };

  /* ── Full My Bets page layout (isHome=false) — design-matched ── */
  return (
    <div id="BLM-myBets" className="grid gap-4 mt-2" style={{ gridTemplateColumns: "repeat(2, minmax(0, 1fr))" }}>
      {myBets?.map((mb, index) => {
        const allCashoutEnabled = mb?.bets?.every(
          (bet) => bet?.odd?.fixture_market?.cashout_status === "1"
        );
        const haveSomeLiveGame = mb?.bets?.some(
          (bet) => bet?.odd?.fixture_market?.fixture?.status === "live"
        );
        const legs = mb?.bets ?? [];
        const visibleLegs = legs.slice(0, 3);
        const hiddenCount = legs.length - 3;
        const dateStr = formatDate(mb?.created_at);
        const isJackpot = mb?.jackpot_id != null && String(mb.jackpot_id) !== "0";
        const rawActualStake = mb?.stake_after_tax;
        const actualStake =
          props.category === "Spribe" || mb?.game || mb?.turbo_gametype_id || rawActualStake == null || rawActualStake === ""
            ? null
            : rawActualStake;

        return (
          <div
            key={index}
            className="rounded-xl overflow-hidden bg-[var(--surface-2)] !border !border-[var(--border-subtle)] flex flex-col justify-between"
          >
            <div>
              {/* Card header */}
              <div className="flex items-center justify-between px-4 pt-4 pb-2.5">
                <div className="flex items-center gap-2 min-w-0">
                  <span className="text-[var(--text-muted)] text-xs font-semibold tracking-wider uppercase truncate">
                    {props.category === "Spribe"
                      ? `${t("mybets_action_label", "Action")}: ${mb?.action_id}`
                      : getBetsCountUpper(mb?.bets ?? [], mb)}
                  </span>
                  {haveSomeLiveGame && (
                    <span className="flex items-center gap-1 text-red-500 font-bold text-[10px] whitespace-nowrap">
                      <span className="w-1.5 h-1.5 bg-red-500 rounded-full animate-pulse" />
                      <Trans i18nKey="mybets_live_badge">LIVE</Trans>
                    </span>
                  )}
                  <span className="text-[9px] font-bold px-1.5 py-0.5 rounded bg-[var(--gold-a12)] text-[var(--gold-500)] !border !border-[var(--gold-a32)] tracking-[0.08em] uppercase whitespace-nowrap">
                    <Trans i18nKey="mybets_tab_open">OPEN</Trans>
                  </span>
                </div>
                <div className="flex items-center gap-0.5 flex-shrink-0">
                  <span className="text-[11px] text-[var(--text-muted)] font-mono">
                    {props.category === "Spribe" ? `${mb?.action_id}` : `BT-${mb?.id}`}
                  </span>
                  <ChevronRight className="w-3.5 h-3.5 text-[var(--text-muted)]" />
                </div>
              </div>

              {/* Date row */}
              {dateStr && (
                <div className="px-4 pb-2 text-xs text-[var(--text-muted)] font-mono">{dateStr}</div>
              )}

              {/* Simplified leg list — fixture names only, max 3 + "and N other matches" */}
              <div className="px-4 pb-3 space-y-1.5">
                {visibleLegs.map((bet, i) => {
                  const fixture = bet?.odd?.fixture_market?.fixture;
                  const competitors = fixture?.competitors || [];
                  return (
                    <div key={i} className="text-sm font-semibold text-white leading-snug">
                      {competitors[0]?.name ?? "-"} v {competitors[1]?.name ?? "-"}
                    </div>
                  );
                })}
                {hiddenCount > 0 && (
                  <div className="text-xs text-[var(--text-muted)] font-medium truncate">
                    {t("mybets_and_label", "and")} {hiddenCount} {hiddenCount === 1 ? t("mybets_other_match", "other match") : t("mybets_other_matches", "other matches")}
                  </div>
                )}
                {mb?.game && (
                  <div className="text-sm font-semibold text-white">{mb.game.game_name}</div>
                )}
              </div>

              {/* Footer: STAKE / TOTAL ODDS / RETURNS (jackpot tickets show their max prize) */}
              <div className="grid grid-cols-3 px-4 pt-3 pb-3">
                <div>
                  <div className="text-[9px] font-bold text-[var(--text-muted)] uppercase tracking-wider mb-1 truncate"><Trans i18nKey="mybets_stake_label">Stake</Trans></div>
                  <div className="text-sm font-bold text-white tabular-nums">
                    {currency} {formatAmount(mb?.stake ?? mb?.amount ?? 0)}
                  </div>
                  {actualStake !== null && (
                    <div className="mt-0.5 text-[10px] text-[var(--text-muted)] tabular-nums truncate">
                      {t("mybets_actual_stake_label", "Actual Stake")}: {currency} {formatAmount(actualStake)}
                    </div>
                  )}
                </div>
                <div className="text-center">
                  <div className="text-[9px] font-bold text-[var(--text-muted)] uppercase tracking-wider mb-1 truncate"><Trans i18nKey="mybets_total_odds_label">Total Odds</Trans></div>
                  <div className="text-sm font-bold text-white tabular-nums">
                    {mb?.game || isJackpot || !mb?.total_odds ? "-" : parseFloat(mb.total_odds).toFixed(2)}
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-[9px] font-bold text-[var(--text-muted)] uppercase tracking-wider mb-1 truncate">
                    {isJackpot ? t("mybets_to_win_label", "To Win") : t("betslip_returns", "Returns")}
                  </div>
                  <div className="text-sm font-bold text-[var(--gold-500)] tabular-nums">
                    {formatAmount(isJackpot ? mb?.jackpot?.max_price : mb?.to_win) === "-" ? "-" : `${currency} ${formatAmount(isJackpot ? mb?.jackpot?.max_price : mb?.to_win)}`}
                  </div>
                </div>
              </div>
            </div>

            {/* Cash Out button */}
            {allCashoutEnabled && mb?.is_signup_freebet_used !== 1 && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  props.setIsLoadingId(mb?.id);
                  getCheckoutSession({ ticket_id: mb.id })
                    .then((res) => {
                      props.setIsCashout(true);
                      props.setTicketDetails(res?.data?.data);
                    })
                    .catch((e) => {
                      toastr.error(e?.response?.data?.message || t("mybets_cashout_error_message", "An error occurred while processing cashout. Try again later."));
                    })
                    .finally(() => { props.setIsLoadingId(null); });
                }}
                disabled={props.isLoadingId === mb?.id}
                className="mx-4 mb-4 flex items-center justify-center gap-2 bg-white/5 hover:bg-white/10 text-white font-bold text-xs py-2.5 rounded-lg transition-colors uppercase tracking-wide !border !border-[var(--border-subtle)] truncate"
              >
                <Receipt size={14} className="text-[var(--gold-500)]" />
                {props.isLoadingId === mb?.id
                  ? t("mybets_please_wait", "Please wait...")
                  : mb?.cashout_amount
                    ? `${t("mybets_cash_out_button", "Cash Out")} ${currency} ${parseFloat(mb.cashout_amount).toFixed(2)}`
                    : t("mybets_cash_out_button", "Cash Out")}
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default withRouter(OpenBets);
